export const VACATION_HOME_ABROAD = {
  nickname: 'PRODUCTS.VACATION_HOME_ABROAD.nickname',
  icon:'vacation-home-abroad'
};
